module.exports = __webpack_public_path__ + "img/GemueseGaertner-DR-160.498c52c6.jpg";